import { render, staticRenderFns } from "./AgentAppPermissions.vue?vue&type=template&id=e27c9464"
import script from "./AgentAppPermissions.vue?vue&type=script&lang=js"
export * from "./AgentAppPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports